import React, { useState, useEffect } from 'react';
import HeaderMobile from './HeaderMobile.js';
import Header from './Header.js';
import Sidebar from './Sidebar.js';
import { useNavigate, Link } from 'react-router-dom'; // Use useNavigate from react-router-dom
import Footer from './Footer.js';  // Import Footer component
import { Spinner } from 'react-bootstrap'; // Adding Bootstrap Spinner for loading indicator
import { Alert } from 'react-bootstrap'; // Bootstrap Alert for error message
import { BASE_URL } from "./Constants.js";

const Manage_Mapping = () => {
  const [users, setUsers] = useState([]); // State to store users data
  const [filteredUsers, setFilteredUsers] = useState([]); // State to store filtered users data based on search
  const [user, setUser] = useState([]); // State to store user profile data
  const [loading, setLoading] = useState(true); // State for loading indicator
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [error, setError] = useState(null); // State for error handling
  const [searchQuery, setSearchQuery] = useState(''); // State to store search query
  const navigate = useNavigate(); // Replace useHistory with useNavigate
  const [areas, setAreas] = useState([]); // State to store dress types
  const [dressTypes, setDressTypes] = useState([]); // State to store dress types
  const [dressSizes, setDressSizes] = useState([]); // State to store dress types
  const [dressColors, setDressColors] = useState([]); // State to store dress types
  // Define the handleAddDressSize function
  const handleMapping = () => {
    navigate('/mapping'); // Navigate to the "Add Mapping" page
  };

  // Fetch user profile on component mount
  useEffect(() => {
    const token = localStorage.getItem('authToken');
    console.log(token); // for debugging
    const fetchProfile = async () => {
      try {
        const response = await fetch(`${BASE_URL}profile`, {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        });

        const data = await response.json();
        setUser(data.profile.is_uniform_access_given); // Assuming the response contains the user profile info
      } catch (error) {
        setError(error.message); // Handle errors
        console.error('Error fetching profile:', error);
      } finally {
        setLoading(false); // Set loading to false after data fetch completes
      }
    };

    fetchProfile();
  }, []); // Empty dependency array ensures this runs only once when the component mounts
   // Fetch dress types data from the API when the component mounts

   useEffect(() => {
    const fetchDressTypes = async () => {
      try {
        const token = localStorage.getItem('authToken');
        console.log(token);

        // If no token is found, handle the error
        if (!token) {
          setError('No token found!');
          setLoading(false);
          return;
        }

        const response = await fetch(`${BASE_URL}areas`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
          },
        });

        const data = await response.json();
        console.log('Fetched dress types:', data);

        if (data && data.areas && Array.isArray(data.areas)) {
          // Filter out dress types with status 'A'
          const activeAreas = data.areas.filter(area => area.status === 'A');
          setAreas(activeAreas); // Set active dress types
        }
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchDressTypes();
  }, []); // Only runs once when the component mounts
   useEffect(() => {
    const fetchDressTypes = async () => {
      try {
        const token = localStorage.getItem('authToken');
        console.log(token);

        // If no token is found, handle the error
        if (!token) {
          setError('No token found!');
          setLoading(false);
          return;
        }

        const response = await fetch(`${BASE_URL}dress_types`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
          },
        });

        const data = await response.json();
        console.log('Fetched dress types:', data);

        if (data && data.dressTypes && Array.isArray(data.dressTypes)) {
          // Filter out dress types with status 'A'
          const activeDressTypes = data.dressTypes.filter(type => type.status === 'A');
          setDressTypes(activeDressTypes); // Set active dress types
        }
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchDressTypes();
  }, []); // Only runs once when the component mounts

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const token = localStorage.getItem('authToken');
        console.log(token);

        // If no token is found, handle the error
        if (!token) {
          setError('No token found!');
          setLoading(false);
          return;
        }

        const response = await fetch(`${BASE_URL}dress_sizes`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
          },
        });

        

        const data = await response.json();
        console.log('Fetched data:', data);

        if (data && data.dressSizes && Array.isArray(data.dressSizes)) {
          // Filter out users with status 'A'
          const activeDressSizes = data.dressSizes.filter(user => user.status === 'A');
          setDressSizes(activeDressSizes);
        
        } 
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchUsers();
  }, []); // Only runs once when the component mounts

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const token = localStorage.getItem('authToken');
        console.log(token);

        // If no token is found, handle the error
        if (!token) {
          setError('No token found!');
          setLoading(false);
          return;
        }

        const response = await fetch(`${BASE_URL}dress_colors`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
          },
        });

        

        const data = await response.json();
        console.log('Fetched data:', data);

        if (data && data.dressColors && Array.isArray(data.dressColors)) {
          // Filter out users with status 'A'
          const activeDressColors = data.dressColors.filter(user => user.status === 'A');
          setDressColors(activeDressColors);
        
        } 
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchUsers();
  }, []); // Only runs once when the component mounts

  // Function to get the dress type name by ID
  const getAreaName = (id) => {
    const area = areas.find(a => a.id === id);
    return area ? area.area : 'Unknown';
  };

  // Function to get the dress type name by ID
  const getDressTypeName = (id) => {
  const dressType = dressTypes.find(type => String(type.id) === String(id));
  return dressType ? dressType.dress_type : 'Unknown';
};

  // Function to get the dress type name by ID
  const getDressSizeName = (id) => {
    const dressSize = dressSizes.find(type => type.id === id);
    return dressSize ? dressSize.dress_size : 'Unknown';
  };

  // Function to get the dress type name by ID
  const getDressColorName = (id) => {
    const dressColor = dressColors.find(type => type.id === id);
    return dressColor ? dressColor.dress_color : 'Unknown';
  };

  // Fetch mapping data from the API when the component mounts
  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const token = localStorage.getItem('authToken');
        console.log(token);

        // If no token is found, handle the error
        if (!token) {
          setError('No token found!');
          setLoading(false);
          return;
        }

        const response = await fetch(`${BASE_URL}mapping`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
          },
        });

        if (!response.ok) {
          throw new Error('Failed to fetch mapping data');
        }

        const data = await response.json();
        console.log('Fetched mapping data:', data);

        if (data && data.mapping && Array.isArray(data.mapping)) {
          // Filter out users with status 'A'
          const activeMapping = data.mapping.filter(mapping => mapping.status === 'A');
          setUsers(activeMapping);
          setFilteredUsers(activeMapping); // Initially set filtered users to all active mappings
        } else {
          setError('No mappings found');
        }
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchUsers();
  }, []); // Only runs once when the component mounts

  // Handle search input change and filter the users based on dress_color
const handleSearch = (e) => {
  const query = e.target.value.toLowerCase().trim();
  setSearchQuery(query);

  if (query === '') {
    setFilteredUsers(users);
  } else {
    const filteredData = users.filter((user) => {
      const areaName = (getAreaName(user.area_id) || '').toLowerCase();
      const typeName = (getDressTypeName(user.type_id) || '').toLowerCase(); // <-- mapped name
      const sizeName = (getDressSizeName(user.size_id) || '').toLowerCase();
      const colorName = (getDressColorName(user.color_id) || '').toLowerCase();
      const gender = (user.gender || '').toLowerCase();
      const cost = (user.cost || '').toString().toLowerCase();

      return (
        areaName.includes(query) ||
        typeName.includes(query) ||   // ✅ "apron" will work now
        sizeName.includes(query) ||
        colorName.includes(query) ||
        gender.includes(query) ||
        cost.includes(query)
      );
    });

    setFilteredUsers(filteredData);
  }
};



  const handleDelete = (id) => {
    // Show confirmation dialog
    const confirmDelete = window.confirm(`Are you sure you want to deactivate ${id}?`);
  
    if (confirmDelete) {
      const token = localStorage.getItem('authToken'); // Get the token for authorization
  
      // Create a FormData object
      const formData = new FormData();
      formData.append('id', id); // Append the id to the FormData object
  
      // Send POST request to API to deactivate the dress color
      fetch(`${BASE_URL}delete_dresscolor`, {
        method: 'POST', // Use POST method for FormData
        headers: {
          'Authorization': `Bearer ${token}`,
          // No need to set 'Content-Type' when using FormData, the browser will do it for you
        },
        body: formData, // Send the FormData as the request body
      })
        .then(response => response.json())
        .then(data => {
          if (data.status) {
            // Redirect to the current page after successful deletion
            window.location.href = window.location.href; // This reloads the current page
          } else {
            // Handle failure if the response indicates a failure
            alert('Failed to deactivate the dress color. Please try again.');
          }
        })
        .catch(err => {
          console.error('Error:', err);
          alert('An error occurred while deactivating the dress color.');
        });
    }
  };

  if (loading) {
    return (
      <div className="loading-container">
        <Spinner animation="border" variant="primary" />
      </div>
    );
  }

  if (error) {
    return (
      <div className="error-container">
        <Alert variant="danger">{error}</Alert>
      </div>
    );
  }
  const handleToggleSidebar = () => {
    if (window.innerWidth >= 992) {
      setIsSidebarOpen(prev => !prev);
    }
  };
  return (
    <>
      <div className="page-wrapper">
        <HeaderMobile />
        <Sidebar isOpen={isSidebarOpen} />
        <div className="page-container" style={{
        marginLeft: isSidebarOpen && window.innerWidth >= 992 ? '300px' : '0',
        transition: 'margin-left 0.3s ease',
        
      }}>
        <Header onToggleSidebar={handleToggleSidebar} isSidebarOpen={isSidebarOpen}/>
          <div className="main-content">
            <div className="section__content section__content--p30">
              <div className="container-fluid">
                <div className="row">
                  <div className="col-lg-12">
                    <div className="row">
                      <div className="col-lg-10">
                        {user === 'Y' && (
                          <div className="d-flex justify-content-between align-items-center mb-3">
                            {/* Add Mapping Button */}
                            <button
                              className="btn btn-primary btn-lg"
                              onClick={handleMapping}
                            >
                              <i className="fas fa-plus"></i> Add Mapping
                            </button>
                          </div>
                        )}
                      </div>
                      <div className="col-lg-2">
                        {/* Search input field */}
                        <div className="mb-3">
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Search Dress Color"
                            value={searchQuery}
                            onChange={handleSearch}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="table-responsive table--no-card m-b-30">
                      <table className="table table-bordered table-striped">
                        <thead >
                          <tr>
                            <th>S/N</th>
                            <th>Location ID</th>
                            <th>Type ID</th>
                            <th>Size ID</th>
                            <th>Color ID</th>
                            <th>Cost</th>
                            <th>Gender</th>
                            <th>Edit</th>
                           
                          </tr>
                        </thead>
                        <tbody>
                          {Array.isArray(filteredUsers) && filteredUsers.length > 0 ? (
                            filteredUsers.map((user, index) => (
                              <tr key={user.id}>
                                <td>{index + 1}</td>
                                <td>{getAreaName(user.area_id)}</td>
                                <td>{getDressTypeName(user.type_id)}</td>
                                <td>{getDressSizeName(user.size_id)}</td>
                                <td>{getDressColorName(user.color_id)}</td>
                                <td>{user.cost}</td>
                                <td>{user.gender}</td>
                                <td><Link to={`/edit_mapping/${user.id}`}>
                                  <i className="fa fa-edit" style={{ fontSize: '12px', color: 'green' }}></i>
                                </Link></td>
                                
                              </tr>
                            ))
                          ) : (
                            <tr><td colSpan="7" className="text-center">No mappings found</td></tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Footer />
        </div>
      </div>
    </>
  );
};

export default Manage_Mapping;
